<template>
  <div>
    <a-row type="flex" justify="center">
      <a-col flex="1 1 200px" style="text-align: center; padding-top: 40px;">
        <img src="@/assets/img/user/anonymous.jpg" alt="asdsad" class="responsive" height="200"/>
        
      </a-col>
      <a-col flex="3 3 200px">        
        <a-row type="flex">
          <a-col flex="1 1 200px" class="colsadd">
            {{ this.$t("general.input.name") }}
            <div class="bold">{{ biodata.name }}</div>
          </a-col>
          <br />
          <a-col flex="2 2 200px" class="colsadd">
            {{ this.$t("general.input.testnumber") }}
            <div class="bold">{{ biodata.test_number }}</div>
          </a-col>
        </a-row>
        <a-row type="flex">
          <a-col flex="1 1 200px" class="colsadd">
            {{ this.$t("general.input.ttl") }}
            <div class="bold">{{ biodata.birth }}</div>
          </a-col>
          <br />
          <a-col flex="2 2 200px" class="colsadd">
            {{ this.$t("general.input.company") }}
            <div class="bold">{{ biodata.company }}</div>
          </a-col>
        </a-row>
        <a-row type="flex">
          <a-col flex="1 1 200px" class="colsadd">
            {{ this.$t("general.input.address") }}
            <div class="bold">{{ biodata.address }}</div>
          </a-col>
          <br />
          <a-col flex="2 2 200px" class="colsadd">
            {{ this.$t("general.input.email") }}
            <div class="bold">{{ biodata.email }}</div>
          </a-col>
        </a-row>
        <a-row type="flex">
          <a-col flex="1 1 200px" class="colsadd">
            {{ this.$t("general.input.information") }}
            <div class="bold" ><span v-html="biodata.information" ></span></div>
          </a-col>
          <br />         
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: ["biodata"],
  data() {
    return {        
      title: this.$t("ujian.description.biodata"),
    };
  },
};
</script>
<style scoped>
.bold {
  font-weight: bold;
}
.colsadd {
  padding: 10px;
}

</style>

